import { reportEvent } from '../../sdk/report';

export function ReportGeneralGoShopEnd(params) {
    reportEvent('9900_0_1020', params);
}

export function ReportGeneralGoShopBegin(params) {
    reportEvent('9900_0_1042', params);
}

export function ReportGeneralH5ScreenView(params) {
    reportEvent('9900_0_1062', params);
}

export function ReportGeneralDeeplinkView(params) {
    reportEvent('9900_0_1067', params);
}

export function ReportGeneralMainTabItemClick(params) {
    reportEvent('9900_1_1075', params);
}

export function ReportGeneralAppScreenView(params) {
    reportEvent('9900_0_1076', params);
}

export function ReportGeneralAppLaunch() {
    reportEvent('9900_0_1106');
}

export function ReportGeneralRewardAdPlayBegin(params) {
    reportEvent('9900_0_1179', params);
}

export function ReportGeneralRewardAdPlaySuccess(params) {
    reportEvent('9900_0_1180', params);
}

export function ReportGeneralRewardAdPlayFail(params) {
    reportEvent('9900_0_1181', params);
}

export function ReportGeneralRewardAdClick(params) {
    reportEvent('9900_1_1299', params);
}

export function ReportGeneralNormalAdView(params) {
    reportEvent('9900_0_1302', params);
}

export function ReportGeneralRemoteVideoDeleted(params) {
    reportEvent('9900_0_1303', params);
}

export function ReportGeneralNormalAdClick(params) {
    reportEvent('9900_1_1304', params);
}

export function ReportGeneralPrivacyPolicyNewInstallPopupView() {
    reportEvent('9900_0_1326');
}

export function ReportGeneralPrivacyPolicyUpdatedPopupView(params) {
    reportEvent('9900_0_1327', params);
}

export function ReportGeneralPrivacyPolicyPopupClick(params) {
    reportEvent('9900_1_1328', params);
}

export function ReportGeneralPrivacyPolicyPopupClose(params) {
    reportEvent('9900_1_1329', params);
}

export function ReportGeneralPrivacyPolicyShowPolicyClick() {
    reportEvent('9900_1_1330');
}

export function ReportGeneralPrivacyPolicyShowAgreementClick() {
    reportEvent('9900_1_1331');
}

export function ReportGeneralRewardAdClose(params) {
    reportEvent('9900_1_1350', params);
}

export function ReportGeneralPushAlertView(params) {
    reportEvent('9900_0_1364', params);
}

export function ReportGeneralPushAlertClick(params) {
    reportEvent('9900_1_1365', params);
}

export function ReportGeneralPushAlertClose(params) {
    reportEvent('9900_1_1366', params);
}

export function ReportGeneralTaskView(params) {
    reportEvent('9900_0_1468', params);
}

export function ReportGeneralAppScreenDisappear(params) {
    reportEvent('9900_0_1757', params);
}

export function ReportGeneralAppEnterForeground() {
    reportEvent('9900_0_1758');
}

export function ReportGeneralAppEnterBackground() {
    reportEvent('9900_0_1759');
}

export function ReportGeneralRewardAdLoadFail(params) {
    reportEvent('9900_0_1760', params);
}

export function ReportGeneralJumpThirdPageClick(params) {
    reportEvent('9900_1_2041', params);
}

export function ReportGeneralTakePermissionPopupView(params) {
    reportEvent('9900_0_2491', params);
}

export function ReportGeneralTakePermissionPopupClick(params) {
    reportEvent('9900_1_2492', params);
}

export function ReportGeneralSplashSkipButtonClick(params) {
    reportEvent('9900_1_2493', params);
}

export function ReportGeneralLoginFailView(params) {
    reportEvent('9900_0_2498', params);
}

export function ReportGeneralClipboardServiceButtonClick(params) {
    reportEvent('9900_1_2264', params);
}

export function ReportGeneralLocationPermissionButtonClick(params) {
    reportEvent('9900_1_2666', params);
}

export function ReportGeneralFilePermissionButtonClick(params) {
    reportEvent('9900_1_2667', params);
}

export function ReportGeneralNotificationPermissionButtonClick(params) {
    reportEvent('9900_1_2683', params);
}

export function ReportGeneralScreenshotView() {
    reportEvent('9900_0_2714');
}

export function ReportGeneralScreenshotClick() {
    reportEvent('9900_1_2715');
}

export function ReportGeneralApkDownloadStatus(params) {
    reportEvent('9900_0_2728', params);
}

export function ReportGeneralWechatBindSuccess(params) {
    reportEvent('9900_0_2729', params);
}

export function ReportGeneralWechatBindFail(params) {
    reportEvent('9900_0_2730', params);
}

export function ReportGeneralWechatBindBegin(params) {
    reportEvent('9900_0_2731', params);
}
